import React from "react";
import { motion } from "framer-motion";
import ResumeCard from "./ResumeCard";

const Achievement = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="py-12 font-titleFont flex gap-20"
    >
      <div className="w-full">
        <div className="py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">
            2024 - 2026
          </p>
          <h2 className="text-4xl font-bold">Key Achievements</h2>
        </div>
        <div className="mt-14 w-full min-h-[800px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="API Performance Optimization"
            subTitle="Indexed queries & optimized Prisma operations"
            result="+25%"
            des="Improved core API response times by 25% through indexed queries and optimized Prisma database operations."
          />
          <ResumeCard
            title="Document Rendering Optimization"
            subTitle="Legal document editor — placeholder detection"
            result="+30%"
            des="Reduced document rendering time by 30% through optimized placeholder detection logic in the document editor."
          />
          <ResumeCard
            title="Onboarding Conversion Lift"
            subTitle="Session-aware interactive tracking"
            result="+40%"
            des="Reduced user onboarding drop-off by 40% through an interactive session-aware tracking system."
          />
          <ResumeCard
            title="Auth Reliability Improvement"
            subTitle="JWT + RBAC implementation"
            result="+30%"
            des="Reduced authentication-related support tickets by 30% through robust JWT and RBAC implementation."
          />
          <ResumeCard
            title="Real-time Compliance Engine"
            subTitle="WebSocket fintech platform"
            result="<200ms"
            des="Built a real-time WebSocket compliance engine operating below 200ms latency in a production fintech platform."
          />
          <ResumeCard
            title="S3 Document Lifecycle Architecture"
            subTitle="AWS S3 presigned URL strategy"
            result="+40%"
            des="Reduced server overhead by 40% through AWS S3 presigned URL document lifecycle architecture."
          />
        </div>
      </div>
    </motion.div>
  );
};

export default Achievement;
